import styles from '../Footer.module.scss';

const FooterBlockTitle = ({ text }) => (
  <div className={styles.footer__title}>{text}</div>
);

export default FooterBlockTitle;
